export const gotoAppRoute = (route: string) => {
  const host = process.env.ICLINIC_APP_URL;

  window.location.href = `${host}${
    route.charAt(0) === '/' ? route : `/${route}`
  }`;
};
